import PropTypes from "prop-types";
import React from "react";
import { Button } from "cxa-components";
import { FormattedMessage } from "react-intl";

const TagSelector = ({ groups, linkify, activeDomain, activeSubDomain }) =>
  <ul className="apl-showcase__filter">
    {groups.map(({ name, id, tagList }) =>
      <li key={id}>
        <Button
          secondary
          to={linkify({ healthDomain: id, subDomain: null })}
          active={id.toString() === activeDomain}
        >
          <FormattedMessage id={name} defaultMessage={name} />
        </Button>
        {tagList &&
          <ul>
            {tagList.map(({ name: tagName, id: tagId }) =>
              <li key={tagId}>
                <Button
                  secondary
                  to={linkify({ subDomain: tagId, healthDomain: null })}
                  active={tagId.toString() === activeSubDomain}
                >
                  <FormattedMessage id={tagName} defaultMessage={tagName} />
                </Button>
              </li>
            )}
          </ul>}
      </li>
    )}
  </ul>;

TagSelector.propTypes = {
  groups: PropTypes.array,
  linkify: PropTypes.func,
  activeDomain: PropTypes.string,
  activeSubDomain: PropTypes.string,
};

export default TagSelector;



// WEBPACK FOOTER //
// ./components/elibrary/TagSelector.js